export default __webpack_public_path__ + "static/media/nav4.7200bc89.svg";